import { Injectable } from "@angular/core";
import { ApicallService } from "@core-services/apicall.service";
import { NotificationsModel } from "@modules/notifications/domain/entities/notifications.model";
import { PaginationService } from "@modules/shared/services/pagination.service";
import { CoreStoreFacade } from "@modules/+new/core/core-store/domain/+state/core-store.facade";

@Injectable({
	providedIn: "root"
})
export class NotificationsPaginationService extends PaginationService<NotificationsModel> {
	public constructor(
		private apicallService: ApicallService,
		protected readonly coreStoreFacade: CoreStoreFacade
	) {
		super(coreStoreFacade, apicallService, "messages", "v1", null);
	}

	public convertPaginationList(list): NotificationsModel[] {
		if (!list) {
			return [];
		}

		return list;
	}
}
